import { getJEXLExpServiceProvider } from '@diagentech/exprworks-jexl';
import { ConsequenceExtensionProcessorRegistry, DisplayRuleService } from '@diagentech/exprworks-rule-engine';

class ExpEngine {
  private static instance: ExpEngine;

  private displayRuleService?: DisplayRuleService;

  private initialized: boolean = false;

  private constructor() {}

  static getInstance(): ExpEngine {
    if (!ExpEngine.instance) {
      ExpEngine.instance = new ExpEngine();
    }
    return ExpEngine.instance;
  }

  initialize = () => {
    const displayRuleService = new DisplayRuleService();
    displayRuleService.setProvider(getJEXLExpServiceProvider());
    const consequenceExtensionProcessorRegistry = new ConsequenceExtensionProcessorRegistry();
    displayRuleService.setConsequenceExtensionProcessorRegistry(consequenceExtensionProcessorRegistry);
    this.displayRuleService = displayRuleService;
    this.initialized = true;
  };

  getDisplayRuleService = (): DisplayRuleService => {
    if (!this.displayRuleService) {
      throw new Error(`[DisplayRuleService] is not initialized`);
    }
    return this.displayRuleService;
  };

  isInitialized(): boolean {
    return this.initialized;
  }
}

const expEngine = ExpEngine.getInstance();

export default expEngine;
